import React from "react";
import { Spinner } from "react-bootstrap";

const CenteredSpinner = (props) => (
  <div
    style={{
      top: "70px",
      padding: "80px",
      textAlign: "center",
    }}
  >
    <Spinner size="lg" animation="border" variant="dark" />
    <p>Please Wait...</p>
  </div>
);

export default CenteredSpinner;
